import { type NetworkOption, type StationNetworkConfig } from 'src/types';
import {
  CREATE_STATION_NETWORK_CONFIG_FAILURE,
  GET_STATION_NETWORK_CONFIGS_FAILURE,
  GET_STATION_NETWORK_CONFIGS_SUCCESS,
  GET_STATION_NETWORK_OPTIONS_FAILURE,
  GET_STATION_NETWORK_OPTIONS_SUCCESS,
} from '../actions/stationNetworkConfigs';
import { parseJSON } from '../../lib/format';

export interface NetworkConfigReducer {
  networkConfigs: StationNetworkConfig[];
  options: NetworkOption[];
  error: Error | null;
}

const INITIAL_STATE: NetworkConfigReducer = {
  networkConfigs: [],
  options: [],
  error: null,
};

const networkConfigReducer = (state = INITIAL_STATE, action): NetworkConfigReducer => {
  switch (action.type) {
    case GET_STATION_NETWORK_CONFIGS_SUCCESS:
      return { ...state, networkConfigs: action.data };
    case GET_STATION_NETWORK_CONFIGS_FAILURE:
      return { ...state, error: parseJSON(action.data) };
    case GET_STATION_NETWORK_OPTIONS_SUCCESS:
      return { ...state, options: action.data };
    case GET_STATION_NETWORK_OPTIONS_FAILURE:
      return { ...state, error: parseJSON(action.data) };
    case CREATE_STATION_NETWORK_CONFIG_FAILURE:
      return { ...state, error: parseJSON(action.data) };
    default:
      return state;
  }
};

export default networkConfigReducer;
